import { gql } from "@apollo/client";

export const GET_ASSESSMENT_PURCHASE_STATUS = gql`
  query get_assessment_bundle_purchase_status {
    get_assessment_bundle_purchase_status {
      status
      message
      is_assessment_bundle_purchased
    }
  }
`;

export const GET_USER_ASSESSMENTS = gql`
  query get_user_assessments {
    get_user_assessments {
      status
      message
      mafoi_score
      pdf_url
      assessment_bundle
      assessments {
        id
        purchase_status
        status
        is_mafoi_assessment
        redirection_url
        is_assessment_bundle
        assessments {
          id
          overall_score
          section_wise_score
          assessment {
            id
            additional_details
            name
          }
        }
      }
    }
  }
`;

export const GET_ASSESSMENT_DETAILS = gql`
  query get_assessment_details($id: ID!) {
    get_assessment_details(id: $id) {
      status
      message
      assessment {
        id
        name
        additional_details
        sample_report_url
        assessment_details
        description
      }
    }
  }
`;

export const GET_ASSESSMENT_REPORT = gql`
  query generate_assessment_report {
    generate_assessment_report {
      status
      message
      assessment_report
    }
  }
`;

export const UPDATE_MAFOI_ASSESSMENT_STATUS = gql`
  mutation update_mafoi_assessment_status($input: UpdateMafoiAssessmentStatusInput!) {
    update_mafoi_assessment_status(input: $input) {
      status
      message
      test_url
    }
  }
`;

export const UPDATE_MAFOI_ASSESSMENTS = gql`
  mutation update_mafoi_assessments($input: UpdateMafoiAssessmentsInput!) {
    update_mafoi_assessments(input: $input) {
      status
      message
    }
  }
`;

export const GET_USER_ASSESSMENT = gql`
  query get_user_assessment($id: ID!) {
    get_user_assessment(id: $id) {
      status
      message
      assessment {
        id
        assessment_result
        assessment {
          id
          name
          description
          scaling_factors
          assessment_sections_description
        }
      }
    }
  }
`;
